import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CampaignsService } from 'src/app/services/campaigns.service';
import { MatDialogRef } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { MainService } from 'src/app/services/main.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Observable } from 'rxjs';
import {map, startWith} from 'rxjs/operators';

/* interface Producto {
  id: number;
  sku: string;
  nombre: string;
  descripcion: string;
  archivo: string;
} */

interface Producto {
  buho_sku: string,
  legacy_sku: string,
  product_name: string,
  product_id: number,
  family_id: number,
  planta: string,
  image_url: string
}

@Component({
  selector: 'app-distribution-art-product',
  templateUrl: './distribution-art-product.component.html',
  styleUrls: ['./distribution-art-product.component.scss']
})
export class DistributionArtProductComponent implements OnInit {

  //productos: { id: number, sku: string, nombre: string, descripcion: string, archivo: string }[] = [];
  productSelect: any = null;
  newObj = {};
  blob: string = '';
  public sanitizedSource!: SafeResourceUrl;
  public sanitizedSourceReport!: SafeResourceUrl;
  fileUrl: SafeResourceUrl = '';
  archivos: any = [];
  materialControl = new FormControl();
  productos: Producto[] = [];
  filteredOptions!: Observable<Producto[]>;


  constructor(
      @Inject(MAT_DIALOG_DATA) public data : any,
      private campaignService : CampaignsService,
      private dialogRef: MatDialogRef<DistributionArtProductComponent>,
      private main : MainService,
      public sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.getSkus();
    this.initSelect();

  }

  getSkus(){
    this.main.ShowLoading();
    this.campaignService.getSkus().subscribe(
      (result:any) => {
        this.productos = result.data2.sku_catalog;
        this.productos.sort((a, b) => {
          const nombreA = a.product_name.toLowerCase();
          const nombreB = b.product_name.toLowerCase();

          if (nombreA < nombreB) {
              return -1;
          }
          if (nombreA > nombreB) {
              return 1;
          }
          return 0;
        });
        this.productos = this.productos.filter((e:any) => e.clientes == this.data.strategy.compania)
        if (this.productos.length > 0) {
          /* this.productSelect = this.productos.find(o => o.id === this.productos[0].id);
          this.sanitizedSource = this.sanitizer.bypassSecurityTrustResourceUrl(this.archivos[0]?.file);
          this.sanitizedSourceReport = this.sanitizer.bypassSecurityTrustResourceUrl(this.archivos[0]?.file);
          this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.productSelect.archivo); */
          this.main.HideLoading();
          
        }
      },
      (err:any) => {
          this.main.HideLoading();
          Swal.fire({
            icon: 'error',
            title: 'Error al obtener registros',
            text: 'Ocurrió un error al obtener los registros.'
          });
        
      }
    );
  }

  seleccionarOpcion(event: MatAutocompleteSelectedEvent): void {
    this.main.ShowLoading();
    const productoSeleccionado: Producto = event.option.value; 
    this.productSelect = productoSeleccionado;
    this.sanitizedSource = this.sanitizer.bypassSecurityTrustResourceUrl(this.archivos[0]?.file);
    this.sanitizedSourceReport = this.sanitizer.bypassSecurityTrustResourceUrl(this.archivos[0]?.file);

    const baseUrl = 'https://buhov18test.odoo.com';

    const fullImageUrl = baseUrl + this.productSelect.image_url;
    this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(fullImageUrl);
    this.main.HideLoading();
  }

  guardarSKU(idStrategy: number){
    this.newObj = {
      idStrategy: idStrategy,
      idSku: this.productSelect.product_id
    }

    this.campaignService.saveSku(this.newObj).subscribe(
      (result:any) => {
        this.dialogRef.close();
        Swal.fire("Añadido", "", "success");        
      },
      (err:any) => {
        if(err.error.message != "Error al guardar sku")
        {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Ocurrió un error al guardar los registros.'
          });
        }
      }
    );
  }

  getSourceURL(fileUrl: SafeResourceUrl): SafeResourceUrl {
    return fileUrl;
  }

  clearAutocomplete(event?: Event) {
    if (event) {
        event.stopPropagation();
    }
    this.materialControl.setValue(null);     
    this.productSelect = null;
  }

  // Muestra el nombre del objeto cuando ha sido seleccionado
  displayFn(producto: Producto): string {
    return producto && producto.product_name ? producto.product_name : '';
  }

  initSelect(){
    this.filteredOptions = this.materialControl.valueChanges.pipe(
      startWith(''), 
      map(value => {
        const name = typeof value === 'string' ? value : value?.product_name || ''; 
        return name ? this._filter(name as string) : this.productos.slice();
      })
    );
  }

  private _filter(value: string): Producto[] {
    const filterValue = value.toLowerCase();

    return this.productos.filter(producto => 
      //Aqui comparamos la propiedad 'nombre' del objeto con el texto del input
      producto.product_name.toLowerCase().includes(filterValue) || (producto.legacy_sku && producto.legacy_sku.toLowerCase().includes(filterValue))
    );
  }

  openDropdown(): void {
    if (!this.materialControl.value) {
        this.materialControl.setValue('');
    }
}

}
